import axios from 'axios';
import Cookies from 'js-cookie';
import { User } from '../global-components/src/types';
import { PACOCA_API_URL } from '../global-components/src/utils/vars';

export const PAPO_TOKEN_COOKIE = 'pacoca_papo_token';
export const PAPO_USER_COOKIE = 'pacoca_papo_user';
export const PAPO_REFRESH_TOKEN_COOKIE = 'pacoca_papo_refresh_token';

export type WebSession = {
    access_token: string;
    refresh_token?: string | null;
    user?: User;
};

const sessionCookieOptions = (remember: boolean): Cookies.CookieAttributes => {
    const isLocal = window.location.hostname === 'localhost' || window.location.port !== '';

    return {
        secure: !isLocal,
        sameSite: 'Strict',
        ...(isLocal ? {} : { domain: '.pacoca.net' }),
        ...(remember ? { expires: 365 } : {}),
    };
};

const removeCookie = (name: string) => {
    const options = sessionCookieOptions(false);
    Cookies.remove(name, options);
    Cookies.remove(name);
};

export const savePapoWebSession = (
    session: WebSession,
    fallbackUser: User,
    remember: boolean,
) => {
    const user = {
        ...(session.user ?? fallbackUser),
        token: session.access_token,
        refresh_token: session.refresh_token ?? null,
    };
    const options = sessionCookieOptions(remember);

    Cookies.set(PAPO_TOKEN_COOKIE, session.access_token, options);
    Cookies.set(PAPO_USER_COOKIE, JSON.stringify(user), options);
    Cookies.set(PAPO_REFRESH_TOKEN_COOKIE, session.refresh_token ?? '', options);
};

export const synchronizePapoWebSession = async (
    accessToken: string,
    user: User,
    remember: boolean,
) => {
    const { data } = await axios.post<WebSession>(
        `${PACOCA_API_URL}/sessions/synchronize-web`,
        { target_client: 'frontend-chat' },
        {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
        },
    );

    if (!data?.access_token) return;
    savePapoWebSession(data, user, remember);
};

export const clearPapoWebSession = () => {
    removeCookie(PAPO_TOKEN_COOKIE);
    removeCookie(PAPO_USER_COOKIE);
    removeCookie(PAPO_REFRESH_TOKEN_COOKIE);
};
